export default function StateNameFromIdFilter(states) {
  'ngInject';

  return (stateId) => {
    return states.getStateNameById(stateId);
  };
}
